module.exports = __webpack_public_path__ + "static/media/violent_crime.3c25459b.svg";